(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/bankid-verify/components/bankid-footer.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/bankid-verify/components/bankid-footer.js');
'use strict';

const BankidFooter = _ref => {
  let {
    isDeposit = false
  } = _ref;
  return React.createElement("div", {
    className: "margin-top-1 align-left"
  }, isDeposit && React.createElement("p", null, "F\xF6r att g\xF6ra en ins\xE4ttning fr\xE5n ditt bankkonto kr\xE4vs en signering med Mobilt BankID."), !isDeposit && React.createElement("p", null, "N\xE4r du anv\xE4nder denna tj\xE4nst godk\xE4nner du att din kontoinformation h\xE4mtas fr\xE5n din bank under 180 dagar utan att du beh\xF6ver identifiera dig. Alla ins\xE4ttningar signeras med Mobilt BankID."));
};
svs.accountservicesReact.deposit.swedbankExpress.pages.bankidVerify.components.BankidFooter = BankidFooter;

 })(window);